import { bpSpanPx } from '@jbrowse/core/util';
export function layoutFeature({ feature, layout, bpPerPx, region, showSoftClip, heightPx, displayMode, }) {
    let expansionBefore = 0;
    let expansionAfter = 0;
    // Expand the start and end of feature when softclipping enabled
    if (showSoftClip) {
        const mismatches = feature.get('mismatches');
        const seq = feature.get('seq');
        if (seq) {
            for (const { type, start, cliplen = 0 } of mismatches) {
                if (type === 'softclip') {
                    start === 0 ? (expansionBefore = cliplen) : (expansionAfter = cliplen);
                }
            }
        }
    }
    const [leftPx, rightPx] = bpSpanPx(feature.get('start') - expansionBefore, feature.get('end') + expansionAfter, region, bpPerPx);
    if (displayMode === 'compact') {
        heightPx /= 3;
    }
    if (feature.get('refName') !== region.refName) {
        throw new Error(`feature ${feature.id()} is not on the current region's reference sequence ${region.refName}`);
    }
    const topPx = layout.addRect(feature.id(), feature.get('start') - expansionBefore, feature.get('end') + expansionAfter, heightPx, feature);
    if (topPx === null) {
        return null;
    }
    return {
        feature,
        leftPx,
        rightPx,
        topPx: displayMode === 'collapse' ? 0 : topPx,
        heightPx,
    };
}
